import { gql } from "@/gql";

export const ACTIVE_PROMO_EVENT_QUERY = gql(`
  query ActivePromoEvent {
    activePromoEvent {
      id
      name
      whatsappNumber
      images {
        id
        url
        sortOrder
      }
    }
  }
`);
